import React from 'react';
import { BasePrice } from 'modules/equipment/types';
import { CurrencyInputField } from 'components/form';
import { FieldPath, useFormContext } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';

import { QuoteChargeListingEntity } from '../../../../../types';

interface Props {
  rowIndex: number;
  type: keyof BasePrice;
  attachmentIndex: number;
}

export const AttachmentChargeValue = ({ rowIndex, type, attachmentIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const fields: Record<'valuePath', FieldPath<ListingForm<QuoteChargeListingEntity>>> = {
    valuePath: `bodyFields.${rowIndex}.equipment.attachments.${attachmentIndex}.price.${type}`,
  };

  return (
    <CurrencyInputField
      allowNegative
      control={control}
      name={fields.valuePath}
      textFieldProps={{ variant: 'outlined' }}
    />
  );
};
